import React, { useState } from "react";
import { Link } from "react-router";
import { browserHistory } from "react-router";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton, MenuItem } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

import { Style, StyleDrawer } from "./style.js";
import menu from "../../public/Menu.svg";
import logo from "../../public/PNG transparent file 03@2x.png";
import logo_blue from "../../public/logo_blue.png";
import { withRouter } from "react-router-dom";
import metacoinConfig from "../../metacoin-config";
const Navbar = ({ homepage, page, history }) => {
  const [isMenuBarOpen, setIsMenuBarOpen] = useState(false);

  const toggleMenuBar = e => {
    setIsMenuBarOpen(isMenuBarOpen => !isMenuBarOpen);
  };
  
  return (
    <Style homepage={homepage}>
      <div className={`navbarr ${homepage ? "" : "inner"}`}>
        <span
          onClick={() => {
            history.replace("/");
          }}
          className={`navbar__navbarLogo`}
        >
          <img src={homepage ? logo : logo_blue} alt="logo" />
        </span>

        <span className={`navbar__navbarLinks`}>
          <a className={`link ${page == 1 ? "purple" : ""}`} href="/">
            Home
          </a>
          <a
            className={`link ${page == 2 ? "purple" : ""}`}
            data-style-attr="selected"
            href="/exchange"
          >
            Exchange
          </a>
          <a
            className={`link ${page == 3 ? "purple" : ""}`}
            target="_blank"
            href="https://discord.gg/Jxg8GzZ3kq"
          >
            Community
          </a>
          <a className={`link ${page == 4 ? "purple" : ""}`} href="/whitepaper">
            Whitepaper
          </a>
          <a
            className={`link ${page == 5 ? "purple" : ""}`}
            target="_blank"
            href={`https://github.com/ceto-code/ceto-contract`}
          >
            Contract
          </a>{" "}
          <a className={`link ${page == 6 ? "purple" : ""}`} href="/tutorial">
            Tutorial
          </a>
          <span>
            <IconButton onClick={toggleMenuBar}>
              {/* <MenuIcon style={{ fontSize: "32px", color: " #fff" }} /> */}
              <img
                className="ham"
                src={
                  homepage
                    ? menu
                    : "https://res.cloudinary.com/dgdjabqwr/image/upload/v1609933423/cd3d/Menu_1_tvudd2.png"
                }
                alt="menu"
              />
            </IconButton>
          </span>
        </span>

        {isMenuBarOpen && (
          <StyleDrawer
            anchor="right"
            open={isMenuBarOpen}
            onClose={toggleMenuBar}
          >
            <div
              style={{
                minHeight: "100%",
                background: "#002E8C",
                width: "345px",
              }}
            >
              <MenuItem className="navbar__drawerLink">
                <CloseIcon
                  onClick={toggleMenuBar}
                  style={{ color: "#ffffff" }}
                />
              </MenuItem>
              <MenuItem
                className={`navbar__drawerLink ${page == 1 ? "white_" : ""}`}
                onClick={() => history.replace({ pathname: "/" })}
              >
                Home
              </MenuItem>
              <MenuItem
                className={`navbar__drawerLink ${page == 2 ? "white_" : ""}`}
                onClick={() => history.replace({ pathname: "/exchange" })}
              >
                Exchange
              </MenuItem>
              <MenuItem
                className={`navbar__drawerLink ${page == 3 ? "white_" : ""}`}
                onClick={() => window.open("https://discord.gg/Jxg8GzZ3kq")}
              >
                Community
              </MenuItem>
              <MenuItem
                className={`navbar__drawerLink ${page == 4 ? "white_" : ""}`}
                onClick={() => history.replace({ pathname: "/whitepaper" })}
              >
                Whitepaper
              </MenuItem>
              <MenuItem
                className={`navbar__drawerLink ${page == 5 ? "white_" : ""}`}
                onClick={() =>
                  window.open(
                    `https://github.com/ceto-code/ceto-contract`
                  )
                }
              >
                Contract
              </MenuItem>
              <MenuItem
                className={`navbar__drawerLink ${page == 6 ? "white_" : ""}`}
                onClick={() => history.replace({ pathname: "/tutorial" })}
              >
                Tutorial
              </MenuItem>

              <MenuItem
                className={`navbar__drawerLink ${page == 7 ? "white_" : ""}`}

                onClick={() => history.replace({ pathname: "/faq" })}
              >
                FAQ
              </MenuItem>
            </div>
          </StyleDrawer>
        )}
      </div>
    </Style>
  );
};

export default withRouter(Navbar);
